module.exports = {
    theme: {
        screens: {
            xs: '370px',
            sm: '640px',
            md: '768px',
            lg: '1024px',
            xl: '1280px',
        },
        container: theme => ({
            center: true,
            padding: '0.8rem',
            screens: (() => {
                let {xs, ...screens} = theme('screens') // xs should just be fluid 100%
                return screens
            })()
        }),
        inset: (theme, {negative}) => {
            // const spacing = {
            //     '0': '0',
            //     '1': '0.25rem',
            //     '2': '0.5rem',
            //     '16': '4rem',
            // }
            //

            // const { ...x, px } =

            // let negativeSpacing = negative(theme('spacing'))
            //
            // delete negativeSpacing['-px'] // crashes tailwind compiler in: reduce-css-calc
            //
            // // console.log(negativeSpacing)

            return {
                auto: 'auto',
                ...theme('spacing'),
                ...negative(theme('spacing'))
            }
        },
        extend: {
            borderRadius: {
                sm: '0.125rem',
                default: '0.25rem',
                lg: '1rem',
            },
            colors: {
                // blue: {
                //     100: '#ebf8ff',
                //     200: '#bee3f8',
                //     300: '#90cdf4',
                //     400: '#63b3ed',
                //     500: '#4299e1',
                //     600: '#3182ce',
                //     700: '#2b6cb0',
                //     800: '#2c5282',
                //     900: '#2a4365',
                // },
                purple: {
                    // 100: '#faf5ff',
                    // 200: '#e9d8fd',
                    // 300: '#d6bcfa',
                    300: '#e4d2f1', // primary light

                    400: '#b794f4',
                    // 500: '#9f7aea',
                    500: '#a05dcd', // primary
                    // 600: '#805ad5',
                    // 700: '#6b46c1',
                    // 800: '#553c9a',
                    // 900: '#44337a',
                }
            },
            maxWidth: {
                '3xs': '12rem',
                '2xs': '16rem',
            }
        }
    },
    variants: {},
    plugins: []
}
